"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = noop;
function noop() {}
module.exports = exports["default"];
//# sourceMappingURL=noop.js.map